import { PExtPnexAllianceSelectPage } from "../pages/p.ext.pnex.alliance.select";
import { VanillaListPlayedMatches, VanillaListPlayers, VanillaPlayerTitle, vanillaAdminRewards } from "./cr.ext.vanilla";
import { Box, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import { PExtTwarAllianceSelectPage } from "../pages/p.ext.twar.alliance.select";
import { GREY, INFO_COLOR, MAIN_COLOR, MAIN_COLOR_ACTIVE, SECONDARY_COLOR, WHITE } from "../style/theme";
import { UMargin, UMarginTop, URow, USection } from "../common/ui.page";
import { useOrder } from "./order";
import { useCrusade } from "./crusade";
import { CMatch, CMatchButton, CPlayer } from "./cr.ui.crusade";
import { CSection } from "./cr.ui.page";
import '../style/glow.css'
import { CRUSADE_RELICS_PNEX } from "./unit.relics.pnex";
import { BATTLE_TRAITS_TWAR } from "./unit.traits.twar";
import { BATTLE_TRAITS_PNEX } from "./unit.traits.pnex";
import { useReport } from "./report";
import { useEffect } from "react";
import { Add, Remove } from "@mui/icons-material";
import { TWAR_COLOR } from "./cr.ext.twar";
import { UEditableTextField } from "../common/ui.editable";
import { BStoneIcon } from "./cr.ui.ext.pnex";
import { UIcon } from "../common/ui.icon";
import { BattleTraitButton } from "./cr.ui.unit";
import { useExtPnex } from "./ext.pnex";
import { UListItemButton } from "../common/ui.buttons";

export const PNEX_COLOR = '#12CD89';

function playerCheck(player) {
    return Boolean(player.alliance);
}
function playerCheckModule(player) {
    if (!player.alliance) {
        return <PExtPnexAllianceSelectPage />
    }

    return <></>
}
export function PnexPlayerList() {
    const order = useOrder()
    const crusade = useCrusade()

    const players = crusade.players
        .filter(p => Boolean(p.codex))
        .sort((p1, p2) => p2.wins - p1.wins || p2.cp - p1.cp);
    const alliances = crusade.alliances.sort((a1, a2) => a2.strategicPoints - a1.strategicPoints || a2.campaignPoints - a1.campaignPoints);

    return <CSection>
        <Stack>
            <Typography sx={{ color: GREY[800], fontWeight: 500, }}>Giocatori</Typography>

            <List>
                {alliances.map(a => <Stack key={a.id}>
                    <URow>
                        <ListItemText sx={{ paddingRight: 40 }} primary={a.name} secondary={a.description} />
                        <URow sx={{ margin: 2 }}>
                            <Typography sx={{
                                color: WHITE,
                                fontSize: 20,
                                fontWeight: 400,
                                width: 40,
                            }}>
                                {a.campaignPoints}
                            </Typography>
                            <Typography className="glow" sx={{
                                color: "#F4C92F",
                                fontSize: 20,
                                fontWeight: 600,
                                width: 40,
                                textAlign: 'right',

                            }}>
                                {a.strategicPoints}
                            </Typography>
                        </URow>
                    </URow>
                    {players.filter(p => a.players.includes(p.id)).map(p => <CPlayer key={p.id} player={p} />)}
                </Stack>)}

            </List>

        </Stack>
    </CSection>
}
function PnexReportAfterKills() {
    const report = useReport()
    const match = report.match;

    useEffect(() => {
        if (report.custom.fragments === undefined) {
            report.setCustom({ fragments: 0 })
        }
    }, [])

    function updateFragments(frag) {
        report.setCustom({ fragments: frag })
    }

    return <CSection>

        <UMargin>
            <Stack>
                <Typography sx={{ fontWeight: 600 }}>Frammenti Blackstone</Typography>
                <URow>
                    <Typography sx={{ color: GREY[800] }}>Frammenti aggiuntivi guadagnati dalla missione</Typography>

                    <Stack direction="row" alignItems="center">
                        <IconButton disabled={report.custom.fragments < 1} onClick={() => updateFragments(report.custom.fragments - 1)}>
                            <Remove />
                        </IconButton>
                        <Typography sx={{ fontSize: 16, fontWeight: 600, color: report.custom.fragments > 0 ? TWAR_COLOR : GREY[800], width: 20, textAlign: 'center' }}>
                            <BStoneIcon size={32} fragments={report.custom.fragments} />
                        </Typography>
                        <IconButton onClick={() => updateFragments(report.custom.fragments + 1)}>
                            <Add />
                        </IconButton>
                    </Stack>
                </URow>


            </Stack>
        </UMargin>
    </CSection>
}
export function PnexListPlayedMatches(props) {
    const { matches } = props;
    var lastPhase = 0;
    const ret = [];

    matches.forEach(m => {
        if (m.phase !== lastPhase) {
            ret.push(<Typography sx={{
                padding: 2,
                fontSize: 12,
                fontWeight: 600,
                background: 'linear-gradient(90deg, #AA3344 0%, ' + GREY[100] + ' 100% )',
            }} key={'p' + m.phase}>Fase {m.phase}</Typography>)
            lastPhase = m.phase
        }
        ret.push(<PnexCMatch key={m.id} match={m} />)
    });

    return <>
        {ret.reverse()}
    </>
}

export function PnexCMatch(props) {
    const { match, ...rest } = props;

    return <CMatchButton icon={<>
        {Boolean(match.fragments) && <BStoneIcon size={28} fragments={match.fragments} sx={{ marginRight: 2 }} />}
        {match.winner && <UIcon name="winner" />}
    </>} disabled={true} color={GREY[500]} primary={match.name} secondary={new Date(match.date).toLocaleDateString('it-IT')} />
}

export function PnexPlayerTitle() {
    const order = useOrder()

    return <>
        <UEditableTextField
            restCommit="player/order/edit/name"
            onComplete={order.reload}
            variant="h5"
            defValue={'Crociata di ' + order.player.name}
            value={order.name}

        />
        <UEditableTextField
            restCommit="player/order/edit/description"
            onComplete={order.reload}
            sx={{ fontSize: 12, color: GREY[900], whiteSpace: 'pre-wrap' }}
            defValue={'Racconta la storia del tuo esercito, cosa lo ha condotto fino a questo luogo impuro!\n\rQuali pericoli, insidie ed eresie ne hanno ostacolato o spianato la strada, fino a raggiungere i fasti di oggi?'}
            value={order.description}
            multiline
        />
        <Stack spacing={2} sx={{ marginTop: 2 }} direction={"row"} justifyContent={"center"} alignItems={"center"}>

            <BStoneIcon size={48} fragments={order.fragments} />
            <Stack>
                <Typography sx={{ fontWeight: 500 }}>Frammenti Blackstone</Typography>
                <Typography sx={{ fontSize: 12, color: GREY[800] }}>Guadagna questi frammenti durante la campagna e spendili per potenziare i tuoi ufficiali accedendo a tratti e reliquie del tutto fuori dal comune</Typography>
            </Stack>
        </Stack>
    </>
}

export function playerDetailIcon(player) {
    return <BStoneIcon sx={{ marginRight: 2 }} fragments={player.fragments} />
}

export function pnexAdminRewards() {
    return [...vanillaAdminRewards(),

    {
        enabled: false,
        type: 'pnex.fragments',
        name: 'Frammenti Blackstone',
        params: ['1']
    },

    ]
}

export function PnexCustomRelics(data) {
    const pnex = useExtPnex()
    const { relic, type, disabled, ...rest } = data;

    return <UListItemButton {...rest} disabled={disabled || pnex.fragments < relic.fragments}>
        <BStoneIcon fragments={relic.fragments} sx={{ marginRight: 2 }} />
        <Stack>
            <Typography sx={{ fontWeight: 600 }}>{relic.name}</Typography>
            <Typography sx={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>{relic.description}</Typography>
        </Stack>
    </UListItemButton>
}

export function PnexCustomTraits(props) {
    const pnex = useExtPnex()
    const { coll, req, setReq, currents, ...rest } = props;
    const traits = coll.dices

    return <>
        {Object.keys(traits).filter(k => k.includes("pnex-")).map(k => {
            const trait = traits[k];
            return <BattleTraitButton
                disabled={pnex.fragments < trait.fragments}
                key={k}
                currents={currents}
                trait={trait}
                req={req}
                setReq={setReq}
                icon={<BStoneIcon fragments={trait.fragments} />} />
        })}
    </>
}



export const PNEX_MODULE = {
    playerCheck,
    playerCheckModule,
    playerCrusadeTop: () => <></>,
    playerList: () => <PnexPlayerList />,
    playerDetailIcon,

    matchesListPlayed: (matches) => <PnexListPlayedMatches matches={matches} />,

    unitSections: () => <></>,
    unitStats: () => <></>,
    unitUpgrades: () => <></>,
    customTraits: (props) => <PnexCustomTraits {...props} />,
    battleTraitCall: (id) => { return "pnex/unit/" + id + "/trait/new" },
    customRelics: (props) => <PnexCustomRelics {...props} />,
    relicsCall: (id) => { return "pnex/unit/" + id + "/relic/new" },

    reportAfterKills: () => <PnexReportAfterKills />,
    playerTitle: () => <PnexPlayerTitle />,

    adminRewards: pnexAdminRewards,

    matchCall: (crusadeId, matchId) => 'pnex/match/' + crusadeId + '-' + matchId + '/report/submit',
    docs: ['doc-crusade-core', 'doc-pariah-nexus'],
    relics: CRUSADE_RELICS_PNEX,
    traits: BATTLE_TRAITS_PNEX,
}